// extracted by mini-css-extract-plugin
export default {"copy":"src-components-CopyPopup--copy","hint":"src-components-CopyPopup--hint","error":"src-components-CopyPopup--error"};